import React, { Component } from 'react';

import {
    Popup,
} from '../../index';

import '../../../asset/css/style.css';

import PropTypes from 'prop-types';

import {FaWindowClose} from 'react-icons/fa';

import ReleaseRequest from '../../../request/index.js';

import GLOBALS from '../../../globals.js';

import {toastMessage} from '../../../common/index.js';

import i18n from '../../../i18n';

export default class DeleteProduct extends Component {
    constructor(props) {
        super(props);

        this.deleteProduct = this.deleteProduct.bind(this);
    }

    /**
     * Ürünü silmemize yarayan method
    */
    async deleteProduct() {
        await ReleaseRequest.deleteProduct(this.props.bundleId).then((res) => {
            if (res) {
                GLOBALS.promise.view.emit('refreshProductList');
                GLOBALS.promise.view.emit('onGroupProcess', { show: false });
                toastMessage('success', i18n.get('product:success:delete'));
            }
        })
        .catch(err => {
            toastMessage('error', i18n.get('product:deleting:error'));
        });
    }

    render() {
        return (
            <Popup
                show={true}
                header={`"${this.props.productName}" ${i18n.get('product:delete')}`}
                headerButtons={[{
                    className: 'close-button',
                    type: 'transparent',
                    title: i18n.get('close'),
                    color: '#2b2b2b',
                    icon: {
                        component: <FaWindowClose />,
                        size: 25,
                    },
                    onClick: this.props.onClose,
                }]}
                renderContent={() => (
                    <div style={{color:'#2b2b2b'}}>
                        <span>{i18n.get('are:you:sure:want:delete')}</span>
                    </div>
                )}
                footerButtons={[
                    {
                        color: '#fff',
                        backgroundColor: '#474747',
                        text: i18n.get('delete'),
                        onClick: this.deleteProduct,
                        className: 'footer-button',
                    }
                ]}
            />
        );
    }
}

DeleteProduct.defaultProps = {
    bundleId: '',
    productName: '',
};

DeleteProduct.propTypes = {
    bundleId: PropTypes.string,
    productName: PropTypes.string,
    onClose: PropTypes.func,
};
